/* Main Theme JavaScript */
/* This file contains global theme functionality */

document.addEventListener('DOMContentLoaded', function() {
  // Add your theme-specific JavaScript here
  console.log('Theme loaded successfully');
}); 